<template>
  <div>
    <div class="title">
      <div>{{ $t("RAM.AWS.database.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
        <Button
          type="primary"
          @click="exportAWSDatabaseMetrics"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:relationalDatabaseServiceResource:exportAWSDatabaseMetric'
          ]"
          >{{ $t("common.exportMetricsStatistics") }}</Button
        >
      </div>
    </div>
    <relational-database-service-resource-search
      ref="child"
    ></relational-database-service-resource-search>
    <table-relational-database-service-resource></table-relational-database-service-resource>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import RelationalDatabaseServiceResourceSearch from "../rds/RelationalDatabaseServiceResourceSearch";
import TableRelationalDatabaseServiceResource from "../rds/TableRelationalDatabaseServiceResource";
import Export from "../../aws/Export";

export default {
  name: "RelationalDatabaseServiceResource",
  components: {
    RelationalDatabaseServiceResourceSearch,
    TableRelationalDatabaseServiceResource,
    Export
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.$refs.child.companyId,
          resourceManagement: 1,
          accountType: 0
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.$refs.exportChild.openExport(1);
    },
    export: function(chooseType) {
      var exportDTO = {
        companyId: this.$refs.child.companyId,
        accountName: this.$refs.child.accountNameSearchKey,
        dbInstanceName: this.$refs.child.nameSearchKey,
        engineType: this.$refs.child.engineSearchKey,
        dbInstanceType: this.$refs.child.typeSearchKey,
        state: this.$refs.child.state
      };
      // 点击 是
      if (chooseType == true) {
        this.$refs.exportChild.loading = true;
        exportDTO.exportWithTag = true;
      }
      // 点击 否
      else {
        this.$refs.exportChild.modal_loading = true;
        exportDTO.exportWithTag = false;
      }
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAWSDatabase(exportDTO).then(res => {
        let fileName = this.$t('RAM.export.database');
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        if (chooseType == true) {
          this.$refs.exportChild.loading = false;
        } else {
          this.$refs.exportChild.modal_loading = false;
        }
        // 关闭导出弹出框
        this.$refs.exportChild.exportModal = false;
        this.$Message.destroy();
        this.$Message.success(this.$t('common.exportSuccess'));
      });
    },
    //导出指标统计
    exportAWSDatabaseMetrics: function() {
      this.loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAWSDatabaseMetrics({
          companyId: this.$refs.child.companyId,
          accountName: this.$refs.child.accountNameSearchKey,
          dbInstanceName: this.$refs.child.nameSearchKey,
          engineType: this.$refs.child.engineSearchKey,
          dbInstanceType: this.$refs.child.typeSearchKey,
          state: this.$refs.child.state
        })
        .then(res => {
          let fileName = this.$t('RAM.export.database');
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.loading = false;
          // 关闭导出弹出框
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.title > div:nth-child(1) {
  float: left;
}
.title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/rds/RelationalDatabaseServiceResource.vue